import axios from "axios";

const apiUrl = window.location.origin ? window.location.origin : '';
export const register = {
  url: apiUrl + "/frontapi/users/register",
  method: "POST"
};
export const login = { url: apiUrl + "/frontapi/users/login", method: "POST" };
export const info = { url: apiUrl + "/frontapi/users/info", method: "GET" };
export const certificates = { url: apiUrl + "/frontapi/users/certificates", method: "GET" };
export const qsealCertificates = { url: apiUrl + "/frontapi/users/qseal-certificates", method: "GET" };
export const generateCertificates = { url: apiUrl + "/frontapi/users/generate-certificate", method: "POST" };
export const generateQSEALCertificates = { url: apiUrl + "/frontapi/users/generate-qseal-certificate", method: "POST" };
export const forgot = { url: apiUrl + "/frontapi/users/forgot", method: "POST" };
export const newPassword = { url: apiUrl + "/frontapi/users/newpassword", method: "POST" };
export const confirm = {
  url: apiUrl + "/frontapi/users/confirm",
  method: "POST"
};
export const logout = { url: apiUrl + "/frontapi/users/logout", method: "POST" };
export const settingsList = {
  url: apiUrl + "/frontapi/settings",
  method: "GET"
};
export const usersList = { url: apiUrl + "/frontapi/users", method: "GET" };
export const newsList = {
  url: apiUrl + "/frontapi/news/published",
  method: "GET"
};
export const pagesList = {
  url: apiUrl + "/frontapi/pages/published",
  method: "GET"
};
export const newsCreate = { url: apiUrl + "/frontapi/news", method: "PUT" };
export const newsGetById = { url: apiUrl + "/frontapi/news", method: "GET" };
export const newsGetByPermalink = {
  url: apiUrl + "/frontapi/news/permalink",
  method: "GET"
};
export const pageGetByPermalink = {
  url: apiUrl + "/frontapi/pages/permalink",
  method: "GET"
};
export const newsDelete = { url: apiUrl + "/frontapi/news", method: "DELETE" };

export function request(endpoint, data = {}, get = "") {
  return new Promise((resolve, reject) => {
    axios({
      method: endpoint.method,
      url: endpoint.url + (get ? "/" + get : ""),
      data: data
    })
      .then(response => {
        resolve(response.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}
